module.exports = __webpack_public_path__ + "static/media/Chiller_plant-3.89697705.png";